"use client";
import { CONTACT_US_MARKETING_API } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { Loader2Icon } from "lucide-react";
import { useState } from "react";
import toast from "react-hot-toast";
import React from 'react';

const ContactUsMarketing = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      const url = new URL(CONTACT_US_MARKETING_API);
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(form),
      });

      const body = await res.json();
      const message = body?.message;

      if (res.ok) {
        toast.success(message);
        setIsSubmitted(true);
      } else {
        toast.error(message);
      }

      setErrorMessage("");
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <section className="mx-auto w-11/12 max-w-2xl py-12 md:w-full">
      {isSubmitted ? (
        <div className="text-center">
          <h2 className="text-3xl font-bold">Thank You!</h2>
          <p className="mt-4 text-lg text-gray-600">
            We{"'"}ve received your message, we will get back to you soon!
          </p>
        </div>
      ) : (
        <>
          <h2 className="mb-3 text-3xl font-bold">Contact Us</h2>
          <p className="mb-3 max-w-md text-lg text-gray-600">
            Book a discovery Call Get results in 45 Days!
          </p>

          <form onSubmit={onSubmit}>
          
            <div className="flex flex-col gap-2">
              <label className="mb-1 mt-2 text-gray-600">Name</label>
              <input
                type="text"
                name="name"
                onChange={onChange}
                placeholder="Your name"
                className="w-full rounded-lg border border-slate-300 p-4 focus:outline-gray-200"
                required
              />

              <label className="mb-1 mt-2 text-gray-600">Email</label>
              <input
                type="email"
                name="email"
                onChange={onChange}
                placeholder="Your email"
                className="w-full rounded-lg border border-slate-300 p-4 focus:outline-gray-200"
                required
              />

              <button className="mt-6 rounded-lg bg-brand-primary px-8 py-4 text-center text-lg font-semibold text-white">
                {isLoading ? (
                  <Loader2Icon className="mx-auto h-8 w-8 animate-spin stroke-white" />
                ) : (
                  "Send"
                )}
              </button>
            </div>
          </form>

          <p
            className={cn(
              "text-sm text-red-400 transition-opacity duration-150 ease-linear",
              errorMessage ? "opacity-100" : "opacity-0"
            )}
          >
            {errorMessage}
          </p>
        </>
      )}
    </section>
  );
};

export default ContactUsMarketing;
